import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserProfileConsentsMutationVariables = Types.Exact<{
  userProfileId: Types.Scalars['ID']['input'];
  xTenantId: Types.Scalars['ID']['input'];
  updateUserProfileConsentsInput: Types.UpdateUserProfileConsentsInput;
}>;


export type UpdateUserProfileConsentsMutation = { __typename?: 'Mutation', updateUserProfileConsents: { __typename?: 'UserProfile', consents?: { __typename?: 'Consents', productMarketingAllowed?: { __typename?: 'ProductMarketingAllowed', casino?: { __typename?: 'VerticalProductMarketingAllowed', emailAllowed?: Types.UserProfilesEnumsOptOutStatus | null, smsAllowed?: Types.UserProfilesEnumsOptOutStatus | null, callAllowed?: Types.UserProfilesEnumsOptOutStatus | null, pushNotificationAllowed?: Types.UserProfilesEnumsOptOutStatus | null, postalMailAllowed?: Types.UserProfilesEnumsOptOutStatus | null } | null, sports?: { __typename?: 'VerticalProductMarketingAllowed', emailAllowed?: Types.UserProfilesEnumsOptOutStatus | null, smsAllowed?: Types.UserProfilesEnumsOptOutStatus | null, callAllowed?: Types.UserProfilesEnumsOptOutStatus | null, pushNotificationAllowed?: Types.UserProfilesEnumsOptOutStatus | null, postalMailAllowed?: Types.UserProfilesEnumsOptOutStatus | null } | null } | null } | null } };


export const UpdateUserProfileConsentsDocument = gql`
    mutation UpdateUserProfileConsents($userProfileId: ID!, $xTenantId: ID!, $updateUserProfileConsentsInput: UpdateUserProfileConsentsInput!) {
  updateUserProfileConsents(
    userProfileId: $userProfileId
    xTenantID: $xTenantId
    updateUserProfileConsentsInput: $updateUserProfileConsentsInput
  ) {
    consents {
      productMarketingAllowed {
        casino {
          emailAllowed
          smsAllowed
          callAllowed
          pushNotificationAllowed
          postalMailAllowed
        }
        sports {
          emailAllowed
          smsAllowed
          callAllowed
          pushNotificationAllowed
          postalMailAllowed
        }
      }
    }
  }
}
    `;
export type UpdateUserProfileConsentsMutationFn = Apollo.MutationFunction<UpdateUserProfileConsentsMutation, UpdateUserProfileConsentsMutationVariables>;

/**
 * __useUpdateUserProfileConsentsMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileConsentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileConsentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileConsentsMutation, { data, loading, error }] = useUpdateUserProfileConsentsMutation({
 *   variables: {
 *      userProfileId: // value for 'userProfileId'
 *      xTenantId: // value for 'xTenantId'
 *      updateUserProfileConsentsInput: // value for 'updateUserProfileConsentsInput'
 *   },
 * });
 */
export function useUpdateUserProfileConsentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileConsentsMutation, UpdateUserProfileConsentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileConsentsMutation, UpdateUserProfileConsentsMutationVariables>(UpdateUserProfileConsentsDocument, options);
      }
export type UpdateUserProfileConsentsMutationHookResult = ReturnType<typeof useUpdateUserProfileConsentsMutation>;
export type UpdateUserProfileConsentsMutationResult = Apollo.MutationResult<UpdateUserProfileConsentsMutation>;
export type UpdateUserProfileConsentsMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileConsentsMutation, UpdateUserProfileConsentsMutationVariables>;